<app-page-wrapper>
  <app-loading-spinner *ngIf="!parent;else main_content"></app-loading-spinner>
  <ng-template #main_content>
    <div class="d-flex align-items-center justify-content-between">
      <h1>
        {{parent.Description}}
      </h1>
      <div class="icon">
        <span (click)="startEditObj($event, account)" *ngIf="!editObj" ngbTooltip="Edit">
          <i class="fal fa-pencil-alt pointer fa-2x"></i>
        </span>
        <span class="mr-2" (click)="updateAccount($event)" *ngIf="!saving && editObj === account" ngbTooltip="Save">
          <i class="fal fa-save pointer fa-2x"></i>
        </span>
        <span (click)="cancelEditObj($event, account)" *ngIf="!saving && editObj === account">
          <i class="fal fa-times pointer fa-2x"></i>
        </span>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <ng-container *ngIf="!editObj">
        <!-- <app-add-student-modal [parentId]="parentId" [openModalButtonVisible]="true" (dataRefresh)="getStudents()"
          [studentsInClass]="students">
        </app-add-student-modal> -->
      </ng-container>

    </div>
    <table *ngIf="!editObj" class="table">
      <thead>
        <th>
          <app-sort-toggle columnName="Name" (orderChange)="getStudents()">Student</app-sort-toggle>
        </th>
        <th>ID</th>
        <th>Expiration Date</th>
        <th></th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let student of parent.Students" [class.hover]="editObj !== student && deleteObj !== student"
          (click)="goToRoute(student, '/parent/students/' + student.ID )">
          <td>
            <div class="d-flex">
              <!-- <app-profile-picture class="mr-2" [name]="student.Name"></app-profile-picture> -->
              <span>{{ student.Name }}</span>
              <input class="ml-2 form-control" *ngIf="editObj === student" [(ngModel)]="editObj.Name"
                disabled="{{ saving }}">
            </div>
          </td>
          <td>
            <span>{{ student.ID }}</span>
            <input class="form-control" *ngIf="editObj === student" [(ngModel)]="editObj.ExternalID"
              disabled="{{ saving }}">
          </td>
          <td>
            <span>{{ student.ExpirationDate | date }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="editObj === account && account" class="row mt-3">
      <div class="form-group col-md-6">
        <label for="user-name">Name</label>
        <input id="user-name" class="form-control" [(ngModel)]="editObj.Name" disabled="{{ saving }}">
      </div>
      <div class="form-group col-md-6">
        <label for="user-id">ID</label>
        <input id="user-id" class="form-control" [(ngModel)]="editObj.ExternalID" disabled="{{ saving }}">
      </div>
      <div class="form-group col-md-6">
        <label for="email">Email</label>
        <input id="email" class="form-control" [(ngModel)]="editObj.Email" disabled="{{ saving }}">
      </div>
      <div class="form-group col-md-6">
        <label for="new-password">New Password</label>
        <input id="new-password" class="form-control" [(ngModel)]="editObj.Password" disabled="{{ saving }}">
      </div>
    </div>
  </ng-template>
</app-page-wrapper>